export default __webpack_public_path__ + "static/media/infiltration_ponds.00749f26.png";